import { jsx as _jsx } from "react/jsx-runtime";
export function ExternalLink(props) {
    return _jsx("a", { ...props, target: "_blank", rel: "noreferrer noopener" });
}
